<template>
    <div class="row">
        <div class="small-12 columns" :class="{ error: showBankNameErrorText }">
            <label>
                Name der Kontobank
                <input type="text" v-model="formData.bank_name"/>
            </label>
            <small class="error" v-if="showBankNameErrorText">
                {{ bankNameErrorText }}
            </small>
        </div>
        <div class="small-12 columns bank-mail-input-container" :class="{ error: showBankMailErrorText }">
            <label>
                E-Mail Adresse der Bank
                <input class="bank-mail-input" :class="{ error: showBankMailErrorText }" type="text" v-model="formData.bank_mail"/>
            </label>
            <small class="error" v-if="showBankMailErrorText">
                {{ bankMailErrorText }}
            </small>
        </div>
        <div @click.stop.prevent class="hint small-12 columns">
            <i>(Wo finde ich die E-Mail Adresse der Bank?)
                <span class="hint-text panel">
                    Im Impressum auf der Internetseite der Bank muss eine E-Mail Adresse angegeben werden, unter der die
                    Bank rechtsgeschäftliche Erklärungen entgegennimmt.
                </span>
            </i>
        </div>
        <div class="small-12 columns" :class="{ error: showAccountNumberErrorText }">
            <label>
                IBAN
                <input type="text" v-model="formData.account_number"/>
            </label>
            <small class="error" v-if="showAccountNumberErrorText">
                {{ accountNumberErrorText }}
            </small>
        </div>
        <div class="small-12 columns" :class="{ error: showAccountTypeErrorText }">
            <label>
                Das Konto ist ein...
                <select v-model="formData.account_type">
                    <option
                        v-for="account_type in availableAccountType"
                        :key="account_type.value"
                        :value="account_type.value"
                    >
                        ... {{account_type.title}}
                    </option>
                </select>
            </label>
            <small class="error" v-if="showAccountTypeErrorText">
                {{ accountTypeErrorText }}
            </small>
        </div>
    </div>
</template>

<script>
import TypeHelper from '../../helper/TypeHelper';
import Validation from '../../helper/Validation';
import AccountTypes from '../../constants/AccountTypes';

export default {
    name: 'BankDataFormStep',
    props: {
        caseData: {
            type: Object,
            default: function()
            {
                return {
                    account_type:                                   null,
                    account_number:                                 null,
                    bank_name:                                      null,
                    bank_mail:                                      null,
                    main_account_holder_lawform:                    null,
                    main_account_holder_prename:                    null,
                    main_account_holder_surname:                    null,
                    main_account_holder_mail:                       null,
                    main_account_holder_company_name:               null,
                    is_main_account_holder_minor:                   null,
                    main_account_holder_payment_account_number:     null,
                    has_sub_account_holder:                         null,
                    sub_account_holder_lawform:                     null,
                    sub_account_holder_surname:                     null,
                    sub_account_holder_prename:                     null,
                    is_allowed_representor:                         null,
                    phishing_damage_amount:                         null,
                    phishing_date:                                  null
                }
            }
        }
    },
    data: () => ({
        formData: {
            account_type:                                   null,
            account_number:                                 null,
            bank_name:                                      null,
            bank_mail:                                      null,
        },
        validation: {
            isFormDirty: false,
            isAccountTypeDirty: false,
            isAccountNumberDirty: false,
            isBankNameDirty: false,
            isBankMailDirty: false,
        },
        availableAccountType: AccountTypes.toArray(),
    }),
    computed: {
        showAccountTypeErrorText()
        {
            return (this.validation.isFormDirty ||this.validation.isAccountTypeDirty)
                && TypeHelper.isNotNullOrUndefined(this.accountTypeErrorText);
        },
        showAccountNumberErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isAccountNumberDirty)
                && TypeHelper.isNotNullOrUndefined(this.accountNumberErrorText);
        },
        showBankNameErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isBankNameDirty)
                && TypeHelper.isNotNullOrUndefined(this.bankNameErrorText);
        },
        showBankMailErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isBankMailDirty)
                && TypeHelper.isNotNullOrUndefined(this.bankMailErrorText);
        },
        accountTypeErrorText()
        {
            let validators = [
                Validation.requiresSelect
            ];

            return Validation.runValidation(this.formData.account_type, validators);
        },
        accountNumberErrorText()
        {
            let validators = [
                Validation.isNotNull,
                Validation.isIban
            ];

            return Validation.runValidation(this.formData.account_number, validators);
        },
        bankNameErrorText()
        {
            let validators = [
                Validation.isNotNull
            ];

            return Validation.runValidation(this.formData.bank_name, validators);
        },
        bankMailErrorText()
        {
            let validators = [
                Validation.isNotNull,
                Validation.isEmail
            ];

            return Validation.runValidation(this.formData.bank_mail, validators);
        },
    },
    methods: {
        validate()
        {
            this.validation.isFormDirty = true;

            this.emitValidity();
        },
        emitValidity()
        {
            this.$emit('updateValidity', this.isFormValid());
        },
        isFormValid()
        {
            let isValid = true;
            isValid = isValid && (this.accountTypeErrorText === null);
            isValid = isValid && (this.accountNumberErrorText === null);
            isValid = isValid && (this.bankNameErrorText === null);
            isValid = isValid && (this.bankMailErrorText === null);

            return isValid;
        },
        emitChangedData()
        {
            this.$emit('changeCaseData', this.formData);
        }
    },
    watch: {
        'formData.account_type': function()
        {
            this.validation.isAccountTypeDirty = true;
        },
        'formData.account_number': function()
        {
            this.validation.isAccountNumberDirty = true;
        },
        'formData.bank_name': function()
        {
            this.validation.isBankNameDirty = true;
        },
        'formData.bank_mail': function()
        {
            this.validation.isBankMailDirty = true;
        },
        formData: {
            handler: function()
            {
                this.emitChangedData();
                this.emitValidity();
            },
            deep: true
        },
    }
};
</script>

<style scoped>
    .error label {
        color: #4d4d4d;
    }

    .hint {
        position: relative;
        display: inline-block;
        width: 100%;
        margin-bottom: 10px;
        color: black !important;
        font-size: 0.875rem;
    }

    .hint i {
        color: #4d4d4d;
        border-bottom: 1px solid black;
        cursor: pointer;
    }

    .hint .hint-text {
        visibility: hidden;
        text-align: center;
        padding: 10px;
        border-radius: 6px;
        margin-top: 5px;
        font-style: normal;

        position: absolute;
        z-index: 10000;
        width: 90%;
        top: 100%;
        left: 5%;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }

    .hint i:hover .hint-text {
        visibility: visible;
    }

    .hint i:active .hint-text {
        visibility: visible;
    }

    .hint .hint-text::after {
        content: " ";
        position: absolute;
        bottom: 100%;
        left: 5%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent rgb(0 0 0 / 20%) transparent;
        color: #4f4f4f;
    }

    .bank-mail-input {
        margin-bottom: 2px;
    }

    .bank-mail-input.error {
        margin-bottom: 0px !important;
    }

    .bank-mail-input-container .error {
        margin-bottom: 2px;
    }

    .checkbox-margin {
        margin-right: 2px !important;
    }

    select {
        margin: 0 0 1rem;
    }

    .error select {
        margin-bottom: 0;
    }
</style>